import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import pdfMake from 'pdfmake/build/pdfmake';

@Injectable({
  providedIn: 'root'
})
export class PdfFontService {
  constructor(private http: HttpClient) { }

  async loadFonts() {
    try {
      // Font dosyalarını base64 formatında yükleyin
      const robotoSerifRegular = await this.loadFont('assets/fonts/Roboto/Roboto-Regular.ttf');
      const robotoSerifBold = await this.loadFont('assets/fonts/Roboto/Roboto-Bold.ttf');
      const robotoSerifItalic = await this.loadFont('assets/fonts/Roboto/Roboto-Italic.ttf');
      const robotoSerifBoldItalic = await this.loadFont('assets/fonts/Roboto/Roboto-BoldItalic.ttf');

      if (!robotoSerifRegular || !robotoSerifBold || !robotoSerifItalic || !robotoSerifBoldItalic) {
        throw new Error('One or more fonts failed to load.');
      }

      // pdfMake VFS'ine fontları ekleyin
      (pdfMake as any).vfs = {
        'Roboto-Regular.ttf': robotoSerifRegular,
        'Roboto-Bold.ttf': robotoSerifBold,
        'Roboto-Italic.ttf': robotoSerifItalic,
        'Roboto-BoldItalic.ttf': robotoSerifBoldItalic
      };

      // pdfMake'e fontları tanımlayın
      (pdfMake as any).fonts = {
        RobotoSerif: {
          normal: 'Roboto-Regular.ttf',
          bold: 'Roboto-Bold.ttf',
          italics: 'Roboto-Italic.ttf',
          bolditalics: 'Roboto-BoldItalic.ttf',
        }
      };
    } catch (error) {
    }
  }

  private loadFont(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.http.get(url, { responseType: 'arraybuffer' })
        .subscribe({
          next: (data: ArrayBuffer) => {
            const base64 = this.arrayBufferToBase64(data);  // ArrayBuffer'ı Base64'e dönüştürme
  
            if (base64) {
              resolve(base64);
            } else {
              reject(`Failed to convert font data for ${url}`);
            }
          },
          error: (error) => {
            console.error('Error loading font file:', error);
            reject(error); // Font yüklemede hata oluşursa reddet
          }
        });
    });
  }

  private arrayBufferToBase64(buffer: ArrayBuffer): string {
    try {
      const uintArray = new Uint8Array(buffer);
      const binary = uintArray.reduce((data, byte) => data + String.fromCharCode(byte), '');  // Reduce ile birleştirme
      const base64 = window.btoa(binary);
      return base64;
    } catch (error) {
      throw error;
    }
  }
}
